import styled from 'styled-components/macro';
import { space } from '../../../theme/tokens';

export const PolicyLinkText = styled.p`
  margin-left: ${space[3]};
`;

export * from './LearningAssessments';
